export var GeoTypeKey;
(function (GeoTypeKey) {
    GeoTypeKey["COUNTRY"] = "AD02";
    GeoTypeKey["REGION"] = "AD04";
    GeoTypeKey["MICRO_REGION"] = "AD05";
    GeoTypeKey["PROVINCE"] = "AD06";
    GeoTypeKey["COUNTY"] = "AD07";
    GeoTypeKey["MUNICIPALITY"] = "AD08";
    GeoTypeKey["BOROUGHS"] = "AD09";
    GeoTypeKey["MACRO_NEIGHBORHOOD"] = "NBH1";
    GeoTypeKey["NEIGHBORHOOD"] = "NBH2";
    GeoTypeKey["STATISTICAL_UNIT"] = "STU2";
    GeoTypeKey["STREETS"] = "STRT";
    GeoTypeKey["HOUSE_NUMBER"] = "HONU";
})(GeoTypeKey || (GeoTypeKey = {}));
